import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const CommunicationIcon: FC<IconProps> = ({ fill, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill}>
    <path
      d="M15.23.93A14.89,14.89,0,0,1,29.86,16.11a15.79,15.79,0,0,1-2.31,7.71l4.18,5.39a1.18,1.18,0,0,1,.11,1.21,1.21,1.21,0,0,1-1.1.66l-16.06-.33A15,15,0,0,1,0,15.45,14.79,14.79,0,0,1,15.23.93Zm-.55,27.62,13.75.33-3.08-4a1.19,1.19,0,0,1-.22-.88,1.32,1.32,0,0,1,.22-.88,12.09,12.09,0,0,0,2.2-6.94A12.66,12.66,0,1,0,14.68,28.55Z"
      fill="current"
    />
    <path d="M19.63,12.7H10.94a1.1,1.1,0,0,1,0-2.2h8.69a1.1,1.1,0,1,1,0,2.2Z" fill="current" />
    <path d="M19.63,21.51H10.94a1.11,1.11,0,0,1,0-2.21h8.69a1.11,1.11,0,0,1,0,2.21Z" fill="current" />
    <path d="M22.49,17.1H8.07a1.1,1.1,0,0,1,0-2.2H22.49a1.1,1.1,0,1,1,0,2.2Z" fill="current" />
  </svg>
);
